import { render, staticRenderFns } from "./LoginRecordList.vue?vue&type=template&id=166cb054&"
import script from "./LoginRecordList.vue?vue&type=script&lang=js&"
export * from "./LoginRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports